module.exports = __webpack_public_path__ + "img/t4.030c19a0.png";